/**
 * get URL for auth token generation in case of APP
 * @param {string} reqUrl -> API request url
 * @returns {string}
 */
export const getUrlForAppTokenGeneration = (reqUrl = '') => {
    let contextURL = reqUrl.substr(reqUrl.split('/', 2).join('4').length + 1);
    if (contextURL.indexOf('app/wl-service/') === -1) {
        contextURL =
            contextURL.split('/')[0] +
                '/app/wl-service/' +
                contextURL.substr(contextURL.split('/')[0].length + 1);
    }
    return window.location.protocol + '//' + contextURL;
};
/**
 * function to check for ios app
 * @returns {boolean}
 */
export const isNewIOSApp = () => {
    var _a, _b;
    return typeof window.webkit !== 'undefined' &&
        Boolean((_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.triggerAppEvent);
};
/**
 * function to check for react based thanks app
 * @returns {boolean}
 */
export const hasMyAirtelAppReactObj = () => typeof window.MyAirtelAppReact !== 'undefined';
/**
 * function to check is new thanks app
 * @returns {boolean}
 */
export const isNewThanksApp = () => typeof window.ReactNativeWebView !== 'undefined';
let _isNativeThanksAppTimer = null;
const _isThanksApp = () => isNewThanksApp() || hasMyAirtelAppReactObj() || isNewIOSApp();
/**
 * function to check for airtel mobile app
 * @param isRetry
 * @param retries
 * @returns {boolean}
 */
export const isMobileApp = (isRetry = false, retries = 5) => {
    if (!isRetry)
        return _isThanksApp();
    if (!_isThanksApp() && retries > 0) {
        _isNativeThanksAppTimer = setTimeout(function () {
            return isMobileApp(true, retries - 1);
        }, 50);
    }
    else {
        if (_isNativeThanksAppTimer)
            clearTimeout(_isNativeThanksAppTimer);
        return Promise.resolve(_isThanksApp());
    }
};
/**
 * get API relative url
 * @param conf {any}
 * @param options {any}
 * @returns {string}
 */
export const getAPIRelativeUrl = (conf = {}, options = {}) => {
    var _a, _b;
    let apiRelativeUrl = '';
    // parse the api url without protocol in each case (http://abc.in/akak, https://abc.in/akak, //abc.in/akak)
    if (!conf.injectForAppToken) {
        apiRelativeUrl =
            ((_a = window.location) === null || _a === void 0 ? void 0 : _a.protocol) +
                '//' +
                ((_b = conf.url) === null || _b === void 0 ? void 0 : _b.substr(conf.url.split('/', 2).join(4).length + 1));
    }
    //Inject 'app/wl-service' for token creation in case of app (for DTH api's)
    else {
        apiRelativeUrl = getUrlForAppTokenGeneration(conf.url);
    }
    if (conf.params && Object.keys(conf.params).length) {
        apiRelativeUrl += '?';
        let sortedKeys = Object.keys(conf.params);
        if (options.sortParams) {
            sortedKeys = sortedKeys.sort();
        }
        for (let index = 0; index < sortedKeys.length; index++) {
            let key = sortedKeys[index];
            if (conf.params[key] !== undefined && conf.params[key] !== null) {
                apiRelativeUrl += key + '=' + conf.params[key] + '&';
            }
        }
        if (options.replaceSpecialChar) {
            apiRelativeUrl = apiRelativeUrl.split(' ').join('+');
        }
        apiRelativeUrl = apiRelativeUrl.substring(0, apiRelativeUrl.length - 1);
    }
    return apiRelativeUrl;
};
/**
 *
 * @param value {any}
 * @returns {string}
 */
export const setInCookie = (value) => {
    if (value) {
        for (let i = 0; i < value.length; i++) {
            if (value[i].cexpire !== undefined) {
                document.cookie =
                    value[i].cname +
                        '=' +
                        value[i].cvalue +
                        ';expires=' +
                        value[i].cexpire +
                        ';path=/';
                document.cookie =
                    value[i].cname +
                        '=' +
                        value[i].cvalue +
                        ';expires=' +
                        value[i].cexpire +
                        ';path=/;domain=airtel.in';
            }
            else {
                document.cookie = value[i].cname + '=' + value[i].cvalue + ';path=/';
                document.cookie =
                    value[i].cname + '=' + value[i].cvalue + ';path=/;domain=airtel.in';
            }
        }
    }
    return '';
};
/**
 *
 * @param cname {string}
 * @returns {string}
 */
export const getFromCookie = (cname) => {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};
